'use client'

import React from 'react'
import { clsx } from 'clsx'
import { usePathname } from 'next/navigation'

import type { Header as HeaderType } from '@/payload-types'

import { CMSLink } from '@/components/payload/Link'

export const HeaderNav: React.FC<{ header: HeaderType }> = ({ header }) => {
    const pathname = usePathname()
    const navItems = header?.navItems || []

    return (
        <div className='overflow-hidden h-5'>
            <nav className='relative z-0 grid grid-flow-col gap-4 overflow-x-auto overflow-y-hidden h-8 uppercase'>
                {navItems.map(({ link }, i) => {
                    return (
                        <CMSLink
                            key={i}
                            {...link}
                            appearance='link'
                            className={clsx('font-bold', { 'bg-accent text-accent-foreground px-2 rounded-none': pathname === link.url })}
                        />
                    )
                })}
            </nav>
        </div>
    )
}
